<template>
  <el-card header="รายละเอียดเบื้องต้น">
    <el-row
      type="flex"
      :gutter="32"
      align="middle"
      :style="{ flexWrap: 'wrap' }"
    >
      <el-col
        v-if="customer"
        :md="8"
        :style="{ marginBottom: ['sm', 'md'].includes($mq) ? '1rem' : null }"
      >
        <CustomerDetail
          :image="customer.avatar"
          :name="customer.fullName"
          :tel="customer.tel"
        ></CustomerDetail>
      </el-col>
      <el-col :md="16">
        <MainDetail
          :code="code"
          :date="startDate"
          :duration="duration"
          :weight="weight"
          :amount="amount"
          :interest-per-month="interestPerMonth"
          :mq="$mq"
        ></MainDetail>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
// Libs
import moment from 'moment'

const CustomerDetail = () => import('./CustomerDetail')
const MainDetail = () => import('./MainDetail')

export default {
  components: { CustomerDetail, MainDetail },

  props: {
    customer: {
      type: Object,
      default: () => ({})
    },

    code: {
      type: String,
      default: ''
    },

    startDate: {
      type: Date,
      default: null
    },

    endDate: {
      type: Date,
      default: null
    },

    weight: {
      type: Number,
      default: 0
    },

    amount: {
      type: Number,
      default: 0
    },

    interestPerMonth: {
      type: Number,
      default: 0
    }
  },

  computed: {
    duration() {
      const start = moment(this.startDate).format('Y-MM-DD')
      const end = moment(this.endDate).format('Y-MM-DD')

      const diffDay = moment(end).diff(start) / 1000 / 86400

      return diffDay
    }
  }
}
</script>
